import { render, staticRenderFns } from "./veStuRewardShow.vue?vue&type=template&id=092f79a8&scoped=true"
import script from "./veStuRewardShow.vue?vue&type=script&lang=js"
export * from "./veStuRewardShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092f79a8",
  null
  
)

export default component.exports